import type { EventInput } from '@fullcalendar/core';

import type { CalendarEvent } from '../types/calendarEvent';

export function toFullCalendarEvent(
  event: CalendarEvent,
  resolvedColor: string,
): EventInput {
  return {
    id: event.id,
    title: event.title,
    start: event.start,
    end: event.end,
    allDay: event.allDay,
    backgroundColor: `var(--color-${resolvedColor})`,
    borderColor: `var(--color-${resolvedColor})`,
    extendedProps: {
      module: event.module,
      source: event.source,
      kind: event.kind,
      entityUrl: event.entityUrl,
      facilityId: event.facilityId,
      facilityName: event.facilityName,
      status: event.status,
      meta: event.meta,
      calendarEvent: event,
    },
  };
}
